<template>
  <div class="story">
    <div class="section section1">
      <div class="title">The backstory</div>
    </div>
    <div class="section section2">
      <div
        class="paragraph1 paragraph"
      >In 2015 three Orium teammates—Katie, Jerry, and Amit—created Askaway. It began as a side project, aimed at helping facilitate remote attendee involvement in Q&As, but quickly found traction with our internal teams. Now we use it for just about everything: from company-wide meetings to customer presentations and demos.</div>
      <div
        class="paragraph2 paragraph"
      >Recognizing its value as a remote engagement tool and with so many teams suddenly forced to shift to fully remote work around the world, we're making Askaway available for everyone to use. Make collaboration and teamwork easier with Askaway.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Story",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.story {
  display: flex;
  justify-content: space-between;
  width: 60%;
  padding: 100px 50px;
  margin: 0 auto;
  color: #22272b;
  font-family: "SofiaProRegular";
  border: 20px solid transparent;
  border-image: url("../assets/bg-scrap.jpg") 50 round;
}

.story .section {
  display: flex;
  /* justify-content: space-between; */
}

.story .section1 .title {
  height: 247px;
  font-size: 40px;
  letter-spacing: 0;
  line-height: 53px;
  margin-right: 30px;
  width: 25%;
  font-family: "SofiaProBold";
}

.story .paragraph {
  text-align: left;
  width: 100%;
  font-size: 22px;
  letter-spacing: 0;
  line-height: 32px;
}

.story .section2 {
  display: flex;
  flex-direction: column;
  width: 75%;
}
.story .section2 .paragraph2 {
  margin-top: 40px;
  width: 100%;
  color: #9292a7;
}
.story .logo {
  height: 20px;
  width: 100px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media only screen and (min-width: 1200px) and (max-width: 1448px) {
  .story {
    width: 80%;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  .story {
    width: 80%;
    margin: 0 auto;
    padding: 100px 35px;
  }
}

@media only screen and (min-width: 823px) and (max-width: 1028px) {
  .story {
    width: 100%;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .story {
    width: 100%;
    padding: 20px;
  }
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  .story {
    width: 100%;
    flex-wrap: wrap;
    padding: 20px;
  }

  .story .section1 .title {
    height: 70px;
    width: 100%;
  }

  .story .section2,
  .story .paragraph,
  .story .section2 .paragraph2 {
    width: 100%;
  }

  .story .section1 .title {
    font-size: 30px;
    line-height: 40px;
  }

  .story .paragraph {
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
